import { useState, useEffect } from 'react';
import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    FormLabel,
    Checkbox,
    Text,
} from '@chakra-ui/react';

import { HelpButton, HelpButtonProps } from './HelpButton';

type checklist = {
    label: string;
    value: boolean;
    id: string;
    help?: HelpButtonProps;
    children?: any;
};

interface ChecklistProps {
    name: string;
    onChange: any;
    list: checklist[];
    title: string;
    help?: HelpButtonProps;
}

export const Checklist = ({ name, onChange, list, title, help, ...rest }: ChecklistProps) => {
    const [accordionIndex, setAccordionIndex] = useState<number[]>([-1]);

    useEffect(() => {
        const newIndex = list
            .map((li, index) => ({ ...li, index }))
            .filter((li) => li.value)
            .map((li) => li.index);
        setAccordionIndex(newIndex);
    }, [list]);

    const addAccordian = (numberToAdd: number) => {
        setAccordionIndex([...accordionIndex, numberToAdd]);
    };
    const removeAccordian = (numberToRemove: number) => {
        const filteredList = accordionIndex.filter((number) => number !== numberToRemove);

        setAccordionIndex(filteredList);
    };

    return (
        <Box>
            <FormLabel>
                {title} {help && <HelpButton onClick={help.onClick}></HelpButton>}
            </FormLabel>
            <Box>
                <Accordion allowToggle allowMultiple index={accordionIndex}>
                    {list.map((check, index) => {
                        return (
                            <AccordionItem key={index}>
                                {({ isExpanded }) => {
                                    return (
                                        <>
                                            <h2>
                                                <AccordionButton
                                                    onChange={(e) => {
                                                        isExpanded
                                                            ? removeAccordian(index)
                                                            : addAccordian(index);
                                                        onChange(index, e);
                                                    }}
                                                >
                                                    <Checkbox
                                                        isChecked={check.value}
                                                        onChange={(e) => {
                                                            isExpanded
                                                                ? removeAccordian(index)
                                                                : addAccordian(index);
                                                            onChange(index, e);
                                                        }}
                                                        mr={2}
                                                    />
                                                    <Box
                                                        flex="1"
                                                        textAlign="left"
                                                        onClick={(e) => {
                                                            isExpanded
                                                                ? removeAccordian(index)
                                                                : addAccordian(index);
                                                            onChange(index, e);
                                                        }}
                                                    >
                                                        <Text id={check.id} fontSize="lg">
                                                            {check.label}
                                                        </Text>
                                                    </Box>
                                                </AccordionButton>
                                            </h2>

                                            {check.children && (
                                                <AccordionPanel>{check.children}</AccordionPanel>
                                            )}
                                        </>
                                    );
                                }}
                            </AccordionItem>
                        );
                    })}
                </Accordion>
            </Box>
        </Box>
    );
};
